/**
 * VSS Mega Menu
 * Логика hover/focus мега-меню для десктопа.
 * На мобайле стандартный Dawn drawer-навигация.
 */

class VSSMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.activeItem = null;
    this.closeTimer = null;
  }

  connectedCallback() {
    if (window.innerWidth < 990) return;

    this.items = this.querySelectorAll('.vss-mega-menu__item[data-has-dropdown]');
    this.items.forEach((item) => this.bindItem(item));
  }

  bindItem(item) {
    const trigger = item.querySelector('.vss-mega-menu__trigger');
    const dropdown = item.querySelector('.vss-mega-menu__dropdown');
    if (!trigger || !dropdown) return;

    trigger.addEventListener('mouseenter', () => this.open(item));
    trigger.addEventListener('focus', () => this.open(item));
    item.addEventListener('mouseleave', () => this.scheduleClose(item));
    dropdown.addEventListener('mouseenter', () => this.cancelClose());
    dropdown.addEventListener('mouseleave', () => this.scheduleClose(item));

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close(item);
    });
  }

  open(item) {
    this.cancelClose();
    if (this.activeItem && this.activeItem !== item) {
      this.close(this.activeItem);
    }
    item.setAttribute('data-open', '');
    item.querySelector('.vss-mega-menu__trigger')?.setAttribute('aria-expanded', 'true');
    this.activeItem = item;
  }

  scheduleClose(item) {
    this.closeTimer = setTimeout(() => this.close(item), 120);
  }

  cancelClose() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  close(item) {
    item.removeAttribute('data-open');
    item.querySelector('.vss-mega-menu__trigger')?.setAttribute('aria-expanded', 'false');
    if (this.activeItem === item) this.activeItem = null;
  }
}

customElements.define('vss-mega-menu', VSSMegaMenu);
